import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';

// Components
import InputMedia from '../../../../../molecules/InputMedia/InputMedia';
import FlashMessage from '../../../../../molecules/FlashMessage/FlashMessage';

function MediaPictures({ formik, withSlider }) {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="fs-20 m-b-25">
        {t('camps.marketing.sub.thumbnail')}
      </h3>
      <InputMedia
        name="mainImageMedia"
        medias={formik?.values?.mainImageMedia ? [formik.values.mainImageMedia] : []}
        setMedias={(val) => {
          formik.setFieldTouched('mainImageMedia', true);
          formik.setFieldValue('mainImageMedia', val?.length ? val[0] : null);
        }}
        max={1}
        formik={{
          setFieldTouched: formik.setFieldTouched,
          errors: formik.errors,
          touched: formik.touched,
        }}
      />

      {withSlider ? (
        <>
          <hr className="m-t-40 m-b-40" />

          <h3 className="fs-20 m-b-25">
            {t('camps.marketing.sub.slider')}
          </h3>

          <div className="d-flex m-t-20 m-b-20">
            <FlashMessage message={t('medias.input.minThree')} />
          </div>

          <InputMedia
            name="sliderImageMedias"
            medias={formik?.values?.sliderImageMedias || []}
            setMedias={(val) => formik.setFieldValue('sliderImageMedias', val || [])}
            min={3}
            formik={{
              setFieldTouched: formik.setFieldTouched,
              errors: formik.errors,
              touched: formik.touched,
            }}
          />

          <hr className="m-t-40 m-b-40" />
        </>
      ) : null}
    </div>
  );
}

MediaPictures.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      mainImageMedia: PropTypes.string,
      sliderImageMedias: PropTypes.arrayOf(PropTypes.string),
    }),
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    errors: PropTypes.shape({
      mainImageMedia: PropTypes.string,
      sliderImageMedias: PropTypes.string,
    }),
    touched: PropTypes.shape({
      mainImageMedia: PropTypes.bool,
      sliderImageMedias: PropTypes.bool,
    }),
  }).isRequired,
  withSlider: PropTypes.bool,
};

MediaPictures.defaultProps = {
  withSlider: false,
};

export default MediaPictures;
